import React, { Component } from 'react';
import { IDriverActivitiesGridProps } from '../../types/PropTypes';
import { IDriverActivitiesGridState } from '../../types/stateTypes';
import DriverService from '../../services/driver/driver-service';
import { IdriverActivityDetails, IDriverActivitiesList } from '../../models/driver';
import StandardResponse from '../../models/standard-response';
import { toast } from 'react-toastify';
import Table from '../../components/table/Table';
import moment from 'moment';
import { Common } from '../../utils/constants';
import RequestedDataModal from './RequestedDataModal';
import _ from 'lodash';
import { locale, regionDateAndTime, trimString } from '../../utils';
import DatePicker from 'react-datepicker';
import images from '../../assets/images/index';

class DriverActivitiesGrid extends Component<IDriverActivitiesGridProps, IDriverActivitiesGridState> {
    private driverService: DriverService;
    constructor(props: IDriverActivitiesGridProps) {
        super(props);

        this.state = {
            driverActivitiesList: [],
            columns: [],
            currentPage: 1,
            offset: 0,
            rowsPerPage: 10,
            sortColumn: 'created_date',
            sortOrder: 'desc',
            totalCount: 0,
            showRequestedDataModal: false,
            requestedData: '',
            searchForm: {
                api_url: '',
                start_date: null,
                end_date: null,
            },
            search: {
                api_url: '',
                start_date: null,
                end_date: null,
            },
        };
        this.driverService = new DriverService();
    }
    async componentDidMount() {
        const { t } = this.props;
        const header = [
            {
                label: t('driver.label.apiURL'),
                id: 'api_url',
                sortable: true,
                isVisible: true,
                cell: (row: IdriverActivityDetails) => {
                    return (
                        <span
                            className="d-block text-nowrap-normal"
                            style={{ maxWidth: 300, wordWrap: 'break-word' }}
                            title={row.api_url}
                        >
                            {row.api_url}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.action'),
                id: 'action',
                sortable: true,
                isVisible: true,
                cell: (row: IdriverActivityDetails) => {
                    return (
                        <span className="d-block text-nowrap-normal" title={row.action}>
                            {row.action}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.requestedData'),
                id: 'requested_data',
                sortable: false,
                isVisible: true,
                cell: (row: IdriverActivityDetails) => {
                    return (
                        <span className="d-block text-truncate">
                            {row.requested_data && row.requested_data !== '' ? (
                                <u>
                                    <a
                                        href="#"
                                        className="themeColor"
                                        onClick={(e) => this.showRequestedDataModal(row.requested_data)}
                                    >
                                        {t('driver.label.viewData')}
                                    </a>
                                </u>
                            ) : (
                                '-'
                            )}
                        </span>
                    );
                },
            },
            {
                label: t('driver.label.createdDate'),
                id: 'created_date',
                sortable: true,
                isVisible: true,
                cell: (row: IdriverActivityDetails) => {
                    if (row.created_date) {
                        return moment(row.created_date).format(regionDateAndTime().DATE_TIME_FORMAT_WITH_SECONDS);
                    }
                    return null;
                },
            },
        ];
        this.setState(
            {
                columns: header,
            },
            () => {
                this.syncSearch().then(async () => {
                    const driverActivitiesList = await this.getDriverActivitiesList();
                    this.setState({ ...this.state, driverActivitiesList });
                });
            },
        );
    }
    syncSearch = (): Promise<boolean> => {
        return new Promise((resolve) => {
            const { search, searchForm } = this.state;

            search.api_url = !_.isEmpty(searchForm.api_url) ? trimString(searchForm.api_url) : null;
            search.start_date = _.isDate(searchForm.start_date)
                ? moment(searchForm.start_date).format('YYYY-MM-DD')
                : null;
            search.end_date = _.isDate(searchForm.end_date) ? moment(searchForm.end_date).format('YYYY-MM-DD') : null;

            this.setState({ search }, async () => {
                resolve(true);
            });
        });
    };
    getDriverActivitiesList = async () => {
        let driverActivitiesList: Array<any> = [];
        const { search } = this.state;

        const filterInput = _.pickBy(search, (value) => {
            return !_.isEmpty(value);
        });
        Object.assign(filterInput, {
            limit: this.state.rowsPerPage,
            offset: this.state.offset,
            order: [[this.state.sortColumn, this.state.sortOrder]],
        });
        await this.driverService
            .getDriverActivitiesListById(this.props.driverDetails?.id, filterInput)
            .then(async (res: StandardResponse<IDriverActivitiesList>) => {
                driverActivitiesList = res.Data.rows;
                this.setState({ totalCount: res.Data.count });
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });

        return driverActivitiesList;
    };
    handlePageChange = async (currentPage: number, rowsPerPage: number) => {
        const offset = (currentPage - 1) * rowsPerPage;
        this.setState(
            {
                currentPage: currentPage,
                rowsPerPage: rowsPerPage,
                offset: offset,
            },
            () => {
                this.syncSearch().then(async () => {
                    const driverActivitiesList = await this.getDriverActivitiesList();
                    this.setState({ ...this.state, driverActivitiesList });
                });
            },
        );
    };
    handleSorting = async (columnName: string) => {
        let sortOrder = this.state.sortOrder;
        if (this.state.sortColumn === columnName) {
            sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
        } else {
            sortOrder = 'asc';
        }

        this.setState(
            {
                sortOrder: sortOrder,
                sortColumn: columnName,
            },
            () => {
                this.syncSearch().then(async () => {
                    const driverActivitiesList = await this.getDriverActivitiesList();
                    this.setState({ ...this.state, driverActivitiesList });
                });
            },
        );
    };
    showRequestedDataModal = (message) => {
        this.setState({ requestedData: message, showRequestedDataModal: true });
    };
    closeModal = () => {
        this.setState({ showRequestedDataModal: false, requestedData: '' });
    };
    handleSearch = () => {
        this.setState(
            {
                offset: 0,
                currentPage: 1,
            },
            () => {
                this.syncSearch().then(async () => {
                    const driverActivitiesList = await this.getDriverActivitiesList();
                    this.setState({ ...this.state, driverActivitiesList });
                });
            },
        );
    };
    handleReset = async () => {
        const searchForm = {
            api_url: '',
            start_date: null,
            end_date: null,
        };
        this.setState(
            {
                ...this.state,
                searchForm,
                offset: 0,
                currentPage: 1,
            },
            () => {
                this.syncSearch().then(async () => {
                    const driverActivitiesList = await this.getDriverActivitiesList();
                    this.setState({ ...this.state, driverActivitiesList });
                });
            },
        );
    };
    handleChange = (event) => {
        const { searchForm } = this.state;
        this.setState({
            searchForm: {
                ...searchForm,
                [event.target.name]: event.target.value,
            },
        });
    };
    handleChangeDropdown = (name, option) => {
        const { searchForm } = this.state;
        this.setState({
            searchForm: {
                ...searchForm,
                [name]: option,
            },
        });
    };
    render() {
        const { t } = this.props;
        const { searchForm } = this.state;

        return (
            <>
                <div className="title row align-items-content justify-content-between pb-3">
                    <div className="col-auto col-sm text-truncate pr-0">
                        <h1 className="text-truncate">{`${this.props.driverDetails?.full_name} - ${t(
                            'driver.activities',
                        )}`}</h1>
                    </div>
                    <div className="col-auto">
                        <div className="btn-list">
                            <button
                                title={t('driver.button.back')}
                                type="button"
                                className="btn btn-icon pr-0 btn-outline-primary"
                                onClick={() => this.props.toggleClosePage()}
                            >
                                <img className="icon" src={images.backArrowSVG} alt={t('driver.button.back')} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-outer">
                    <div className="pt-3 px-3">
                        <form
                            noValidate
                            id="driverActivitiesForm"
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSearch();
                            }}
                            autoComplete="off"
                        >
                            <div className="row">
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <input
                                        className="form-control"
                                        name="api_url"
                                        value={searchForm.api_url}
                                        placeholder={t('driver.placeholder.api_url')}
                                        autoComplete="off"
                                        onChange={(e) => this.handleChange(e)}
                                        maxLength={500}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <DatePicker
                                        name="start_date"
                                        className="form-control"
                                        popperClassName={searchForm.start_date ? '' : 'highlight-today'}
                                        selected={
                                            searchForm.start_date !== null && searchForm.start_date !== ''
                                                ? searchForm.start_date
                                                : null
                                        }
                                        placeholderText={t('driver.placeholder.startDate')}
                                        value={
                                            searchForm.start_date !== '' && searchForm.start_date !== null
                                                ? moment(searchForm.start_date).format(
                                                      regionDateAndTime().GENERAL_DATE_FORMAT,
                                                  )
                                                : moment(null)
                                        }
                                        dateFormat={regionDateAndTime().GENERAL_DATE_FORMAT}
                                        maxDate={searchForm.end_date !== null ? searchForm.end_date : moment().toDate()}
                                        onChange={(e) => this.handleChangeDropdown('start_date', e)}
                                        isClearable={true}
                                        locale={locale()}
                                    />
                                </div>
                                <div className="form-group col-md-6 col-lg-4 col-xl-3">
                                    <DatePicker
                                        name="end_date"
                                        className="form-control"
                                        id="example-datepicker"
                                        popperClassName={searchForm.end_date ? '' : 'highlight-today'}
                                        selected={
                                            searchForm.end_date !== null && searchForm.end_date !== ''
                                                ? searchForm.end_date
                                                : null
                                        }
                                        placeholderText={t('driver.placeholder.endDate')}
                                        value={
                                            searchForm.end_date !== '' && searchForm.end_date !== null
                                                ? moment(searchForm.end_date).format(
                                                      regionDateAndTime().GENERAL_DATE_FORMAT,
                                                  )
                                                : moment(null)
                                        }
                                        minDate={searchForm.start_date !== null ? searchForm.start_date : moment(null)}
                                        maxDate={moment().toDate()}
                                        dateFormat={regionDateAndTime().GENERAL_DATE_FORMAT}
                                        onChange={(e) => this.handleChangeDropdown('end_date', e)}
                                        isClearable={true}
                                        locale={locale()}
                                    />
                                </div>
                                <div className="form-group col-md-auto">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mr-2"
                                        title={t('driver.button.search')}
                                    >
                                        <span>{t('driver.button.search')}</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        title={t('driver.button.reset')}
                                        onClick={() => this.handleReset()}
                                    >
                                        <span>{t('driver.button.reset')}</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <Table
                        columns={this.state.columns}
                        data={this.state.driverActivitiesList}
                        rowsPerPage={this.state.rowsPerPage}
                        currentPage={this.state.currentPage}
                        totalCount={this.state.totalCount}
                        sortColumn={this.state.sortColumn}
                        sortOrder={this.state.sortOrder}
                        handlePageChange={this.handlePageChange}
                        handleSorting={this.handleSorting}
                        t={this.props.t}
                        isCheckboxGrid={false}
                    />
                </div>
                {this.state.showRequestedDataModal && (
                    <RequestedDataModal
                        t={this.props.t}
                        showModal={this.state.showRequestedDataModal}
                        closeModal={this.closeModal}
                        requestedData={this.state.requestedData}
                    />
                )}
            </>
        );
    }
}
export default DriverActivitiesGrid;
